<nav class="scroll nav-light">
  <ul class="nav" ui-nav>

    <!-- Dashboard -->
    <li gp-roles
        [userRoles]="['DASHBOARD']"
        testId="dashboard-menu"
        gp-menu-item data-attr="dashboard"
        name="{{ 'MENU.dashboard' | translate }}"
        icon="fa-tachometer-alt"
        [routerLinkActive]="['active']"
        [routerLink]="['dashboard']"></li>

    <!-- My Tasks -->
    <li gp-roles
        [userRoles]="['EMPLOYEE']"
        testId="my-tasks-menu"
        gp-menu-item
        [routerLink]="['/inbox/tasks']"
        [routerLinkActive]="['active']"
        [queryParams]="{status: 'IN_PROGRESS'}"
        [realTimeValue]="communicationsService.tasksUnreadCount"
        class="my-tasks-menu"
        name="{{ 'MENU.MY_TASKS' | translate }}"
        icon="fa-tasks"
        data-attr="my-tasks">
    </li>

    <!-- Employees -->
    <li gp-roles
        [userRoles]="['ONBOARDING_ADMIN', 'PEOPLE_READ', 'PEOPLE_WRITE', 'PEOPLE_PARTIAL_UPDATE', 'PEOPLE_HIRE', 'PEOPLE_TERMINATE', 'PEOPLE_EXTEND', 'MASS_BULK_ACTIONS']"
        testId="people-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.PEOPLE.people' | translate }}"
        icon="fa-users"
        class="people-menu"
        data-attr="people">
      <ul class="nav-sub">
        <li gp-roles
            [userRoles]="['PEOPLE_HIRE']"
            testId="people-hire-menu"
            class="people-hire-menu"
            gp-menu-item
            name="{{ 'EMPLOYEE_HIRE.hire' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/hire']"
            data-attr="people-hire"
            (click)="closeSideModal()">
        </li>
        <li gp-roles
            [isNew]="true"
            *ngIf="displayOnboardingAdmin"
            [userRoles]="['ONBOARDING_ADMIN']"
            testId="onboarding-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'ONBOARDING.onboard' | translate }}"
            [routerLink]="['/onboarding/overview']"
            data-attr="onboarding">
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_READ', 'PEOPLE_WRITE', 'PEOPLE_PARTIAL_UPDATE']"
            testId="people-manage-menu"
            gp-menu-item
            name="{{ 'MENU.manage' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/files']"
            data-attr="people-manage">
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_EXTEND']"
            testId="people-extend-menu"
            gp-menu-item
            name="{{ 'MENU.PEOPLE.extend' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/extend']"
            data-attr="people-extend">
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_TERMINATE']"
            testId="people-leave-menu"
            gp-menu-item
            name="{{ 'EMPLOYEE_LEAVE.terminate' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/leave']"
            data-attr="people-leave">
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_SKILL']"
            testId="people-skills-menu"
            gp-menu-item
            name="{{ 'MENU.skills' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/skills']"
            data-attr="skills-manage">
        </li>
        <li gp-roles
            [userRoles]="['MASS_BULK_ACTIONS']"
            testId="mass-data-update-bulk-update-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.MASS_ACTIONS' | translate }}"
            [routerLink]="['/mass-data-update/overview']"
            data-attr="bulk-update">
        </li>
      </ul>
    </li>

    <!-- Payroll -->
    <li gp-roles
        [userRoles]="['PAYROLL_READ', 'PAYROLL_WRITE', 'PAYROLLPREPARE_READ', 'PAYROLLPREPARE_WRITE', 'PAYROLL_FINALIZE']"
        testId="payroll-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.PAYROLL.payroll' | translate }}"
        icon="fa-money-bill-alt"
        data-attr="payroll">
      <ul class="nav-sub">
        <li gp-roles
            [userRoles]="['PAYROLLPREPARE_READ', 'PAYROLLPREPARE_WRITE']"
            testId="payroll-prepare-menu"
            gp-menu-item name="{{ 'MENU.PAYROLL.prepare' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/prepare']"
            data-attr="payroll-prepare">
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_READ','PAYROLL_WRITE']"
            testId="payroll-calculate-menu"
            gp-menu-item
            name="{{ 'MENU.PAYROLL.calculate' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/calculate']"
            [queryParams]="{sort: 'lastName,firstName,cliRegId'}"
            data-attr="payroll-calculate">
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_READ','PAYROLL_WRITE']"
            testId="payroll-monitor-menu"
            gp-menu-item
            name="{{ 'MENU.PAYROLL.monitor' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/calculation-events']"
            data-attr="payroll-monitor">
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_READ','PAYROLL_WRITE']"
            testId="payroll-analize-menu"
            gp-menu-item
            name="{{ 'MENU.PAYROLL.analyze' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/analyze']"
            data-attr="payroll-analyze">
        </li>
        <li gp-roles
            *ngIf="displayPaymentV2"
            [userRoles]="['PAYROLL_PAYMENT_READ']"
            testId="payroll-pay-menu"
            gp-menu-item
            name="{{ 'MENU.PAYROLL.pay' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/payment']"
            data-attr="payroll-pay">
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_READ','PAYROLL_WRITE', 'PAYROLL_FINALIZE']"
            testId="payroll-finalize-menu"
            gp-menu-item
            name="{{ 'MENU.PAYROLL.finalize' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/payroll/finalize']"
            data-attr="payroll-finalize">
        </li>
      </ul>
    </li>

    <!-- Organization Trees: Company & People trees -->
    <li gp-roles
        [userRoles]="['PEOPLE_READ', 'PEOPLE_WRITE', 'PEOPLE_TREE_READ', 'PEOPLE_TREE_WRITE', 'COMPANY_READ', 'COMPANY_WRITE']"
        testId="organization-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.organization_charts' | translate }}"
        icon="fa-building"
        class="organization-menu"
        data-attr="organization">
      <ul class="nav-sub">
        <li gp-roles
            [userRoles]="['COMPANY_READ', 'COMPANY_WRITE']"
            testId="company-tree-menu"
            gp-menu-item
            data-attr="company-org-tree"
            name="{{ 'MENU.ORGANIZATION.company' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/company/tree']"></li>
        <li gp-roles
            [userRoles]="['PEOPLE_READ', 'PEOPLE_WRITE', 'PEOPLE_TREE_READ', 'PEOPLE_TREE_WRITE']"
            testId="people-tree-menu"
            gp-menu-item
            name="{{ 'MENU.PEOPLE.people' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/employees/tree/tree']"
            data-attr="people-tree">
        </li>
      </ul>
    </li>

    <!-- Post-payroll -->
    <li gp-roles
        [userRoles]="[
        'ACCOUNTANT',
        'POSTPAY_WRITE',
        'POSTPAY_READ',
        'POSTPAY_LOCALHR',
        'POSTPAY_READ_KPI',
        'POSTPAY_WRITE_AGGREGATES',
        'POSTPAY_PAYMENTS',
        'POSTPAY_COLLECTIVE_REPORTS',
        'REPORT_READ',
        'REPORT_WRITE']"
        testId="post-payroll-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.reporting' | translate }}"
        icon="fa-flag-checkered"
        data-attr="post-payroll">
      <ul class="nav-sub">
        <!-- Reports -->
        <li gp-roles
            [userRoles]="['REPORT_READ', 'REPORT_WRITE']"
            testId="reports-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.dynamic_reports' | translate }}"
            [routerLink]="['/reports/manage']"
            data-attr="reports">
        </li>
        <li gp-roles
            [userRoles]="[
            'POSTPAY_WRITE',
            'POSTPAY_PAYMENTS',
            'POSTPAY_COLLECTIVE_REPORTS'
            ]"
            testId="post-payroll-static-menu"
            gp-menu-item
            name="{{ 'MENU.POST_PAYROLL.static_reports' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/postpayroll/post-prepare']"
            data-attr="post-payroll-prepare">
        </li>
        <li gp-roles
            [userRoles]="[
            'POSTPAY_WRITE',
            'POSTPAY_READ',
            'POSTPAY_LOCALHR',
            'POSTPAY_READ_KPI',
            'POSTPAY_WRITE_AGGREGATES',
            'ACCOUNTANT'
            ]"
            testId="post-payroll-interfaces-menu"
            gp-menu-item
            name="{{ 'MENU.POST_PAYROLL.interfaces' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/postpayroll/check']"
            data-attr="post-payroll-check"></li>
      </ul>
    </li>

    <!-- Payrolls validation -->
    <li gp-roles
        [userRoles]="['PAYROLL_VALIDATE']"
        testId="payroll-validation-menu"
        gp-menu-item
        [routerLinkActive]="['active']"
        name="{{ 'MENU.VALIDATION.validate_payrolls' | translate }}"
        icon="fa-suitcase"
        [routerLink]="['/payrolls-validation']"
        data-attr="payrolls-validation">
    </li>

    <!-- Net entreprise -->
    <li gp-roles
        [userRoles]="['NET_ENTREPRISE_WRITE']"
        testId="dsn-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.DSN.dsn_menu_name' | translate }}"
        icon="fa-file"
        data-attr="dsn">
      <ul class="nav-sub">
        <li gp-roles
            [userRoles]="['NET_ENTREPRISE_WRITE']"
            testId="dsn-at-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.DSN.dsn_at_menu_name' | translate }}"
            [routerLink]="['/dsn/absence']"
            data-attr="dsn-at">
        </li>
        <li *ngIf="enableFctu"
            testId="dsn-fctu-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.DSN.dsn_fctu_menu_name' | translate }}"
            [routerLink]="['/dsn/fctu']"
            data-attr="dsn-fctu">
        </li>
      </ul>
    </li>
    <!-- Repository -->
    <li gp-roles
        [userRoles]="['REPOSITORY_READ', 'REPOSITORY_WRITE']"
        testId="repository-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.CONFIGURATION.repository' | translate }}"
        icon="fa-database"
        data-attr="repository">
      <ul class="nav-sub">
        <li gp-menu-item
            testId="repository-tree-menu"
            name="{{ 'MENU.COMPANY.tree' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/configuration/repository/tree']"
            data-attr="repository-tree">
        </li>
      </ul>
    </li>

    <!-- Configuration -->
    <li gp-roles
        [userRoles]="['CONFIGURATION', 'VARIABLE_SETUP_ADMIN', 'LIST_TREE_SETUP_ADMIN', 'HIRE_PROFILE_ADMIN']"
        testId="configuration-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.CONFIGURATION.configuration' | translate }}"
        icon="fa fa-cogs fa-light"
        data-attr="configuration">
      <ul class="nav-sub">
        <li gp-roles [userRoles]="['CONFIGURATION']">
          <a class="menu-anchor"
             [href]="configToolUrl"
             testId="configuration-tool-menu"
             target="_blank">
            <span class="nav-text">
              {{ 'MENU.CONFIGURATION.configtool' | translate }}
            </span>
          </a>
        </li>
        <li gp-roles
            [userRoles]="['VARIABLE_SETUP_ADMIN']"
            testId="variable-setup-menu"
            gp-menu-item
            name="{{ 'MENU.SETTINGS.variable_setup' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/variable-setup']"
            data-attr="variable-setup">
        </li>
        <li gp-roles
            [userRoles]="['LIST_TREE_SETUP_ADMIN']"
            testId="list-setup-menu"
            gp-menu-item
            name="{{ 'MENU.SETTINGS.list_setup' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/list-setup']"
            data-attr="list-setup">
        </li>
        <li gp-roles
            [userRoles]="['HIRE_PROFILE_ADMIN']"
            testId="hire-profile-management"
            gp-menu-item
            name="{{ 'HIRE_PROFILE.hire_profile' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/hire-profile']"
            data-attr="hire-profile">
        </li>
      </ul>
    </li>

    <!-- Administration -->
    <li gp-roles
        [userRoles]="['SETTINGS', 'USER_ROLES_ADMIN', 'PEOPLE_READ', 'PEOPLE_WRITE','CONFIGURATION','EGEN_DOC_READ','EGEN_DOC_WRITE']"
        testId="settings-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.SETTINGS.admin_tools' | translate }}"
        icon="fa fa-screwdriver-wrench fa-light" data-attr="settings">
      <ul class="nav-sub">
        <li gp-roles
            [userRoles]="['SETTINGS']"
            testId="settings-administrate-menu"
            gp-menu-item
            name="{{ 'MENU.SETTINGS.settings' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/administrate']"
            data-attr="settings-administrate">
        </li>
        <li gp-roles
            [userRoles]="['USER_ROLES_ADMIN']"
            testId="settings-user-rights-menu"
            gp-menu-item
            name="{{ 'MENU.SETTINGS.user_rights' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/user-rights', {isExternalAdmin: false}]"
            data-attr="settings-user-right">
        </li>
        <li gp-roles
            [userRoles]="['WORKFLOW_ADMIN', 'PEOPLE_READ', 'PEOPLE_WRITE']"
            testId="settings-workflows-menu"
            gp-menu-item
            name="{{ 'MENU.PROCESS_MONITOR' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/workflows/admin']"
            data-attr="settings-workflows-menu">
        </li>
        <li [routerLinkActive]="['active']"
            [routerLink]="['/sdconnect/admin']"
            [userRoles]="['SDCONNECT_ADMIN','SDC3_ADMIN']"
            data-attr="settings-sdconnect-menu"
            gp-menu-item
            gp-roles
            name="{{ 'MENU.SDCONNECT' | translate }}">
        </li>
        <!-- Template -->
        <li gp-roles
            *ngIf="displayTemplateManagement"
            [userRoles]="['EGEN_DOC_READ','EGEN_DOC_WRITE']"
            testId="template-management"
            gp-menu-item data-attr="template"
            name="{{ 'TEMPLATE.templates' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/templates']">
        </li>
        <li gp-roles
            [userRoles]="['CONFIGURATION']"
            testId="regulations-tree-menu"
            gp-menu-item
            name="{{ 'MENU.CONFIGURATION.regulation' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/configuration/regulation']"
            data-attr="regulations-tree">
        </li>
        <li gp-menu-item testId="accounting-mgmt-menu" *ngIf="displayAccountingManagement"
            name="{{ 'MENU.CONFIGURATION.accounting' | translate }}"
            [routerLinkActive]="['active']"
            [routerLink]="['/configuration/accounting']"
            data-attr="accounting-menu">
        </li>
      </ul>
    </li>

    <!-- Mass actions -->
    <li gp-roles
        [userRoles]="['ABSENCE_MASSMENU', 'VARIABLE_MASSMENU', 'VARIABLE_MASSMENU_NODATES']"
        testId="mass-data-update-menu"
        gp-menu-dropdown
        [routerLinkActive]="['active']"
        name="{{ 'MENU.MASS_ACTIONS' | translate }}"
        icon="fa-users"
        data-attr="mass-data-update">
      <ul class="nav-sub">
        <!-- Absence -->
        <li gp-roles
            [userRoles]="['ABSENCE_MASSMENU']"
            testId="mass-data-update-absence-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.absence' | translate }}"
            [routerLink]="['/mass-data-update/absence']"
            [queryParams]="{isLocalHR: true}"
            data-attr="absence">
        </li>
        <!-- Variable items -->
        <li gp-roles
            [userRoles]="['VARIABLE_MASSMENU', 'VARIABLE_MASSMENU_NODATES']"
            testId="mass-data-update-variable-menu"
            gp-menu-item
            [routerLinkActive]="['active']"
            name="{{ 'MENU.variable' | translate }}"
            [routerLink]="['/mass-data-update/variable']"
            [queryParams]="{isLocalHR: true}"
            data-attr="variable-items">
        </li>
      </ul>
    </li>
    <!-- My space -->
    <ng-container *ngIf="essService.employee">
      <li gp-roles
          [userRoles]="['ESS_PERSONAL_INFO', 'ESS_LEAVE', 'ESS_PAYSLIPS', 'ESS_ASK_FOR_VARIABLE']"
          testId="ess-menu"
          gp-menu-dropdown
          [routerLinkActive]="['active']"
          name="{{ 'MENU.ESS.my_space' | translate }}"
          icon="fa-user-circle"
          data-attr="ess"
          class="ess-menu">
        <ul class="nav-sub">
          <li gp-roles
              [userRoles]="['ESS_PERSONAL_INFO']"
              testId="ess-personal-info-menu"
              gp-menu-item name="{{ 'MENU.ESS.personal_info' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/ess/personal-info']"
              data-attr="ess-personal-info"
              class="ess-personal-info-menu"
              (click)="closeSideModal()">
          </li>
          <li gp-roles
              [userRoles]="['ESS_MY_DOCUMENTS']"
              testId="ess-documents-menu"
              gp-menu-item name="{{ 'DOCUMENTS.employee_documents' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/ess/documents']"
              data-attr="ess-documents"
              class="ess-documents-menu"
              (click)="closeSideModal()">
          </li>
          <li gp-roles
              [userRoles]="['ESS_LEAVE']"
              testId="ess-leave-menu"
              gp-menu-item name="{{ 'MENU.ESS.leave' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/ess/leave-request']"
              data-attr="ess-leave-request"></li>
          <li gp-roles
              [userRoles]="['ESS_ASK_FOR_VARIABLE']"
              testId="ess-claims-menu"
              gp-menu-item name="{{ 'MENU.ESS.claims' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/ess/claims']"
              data-attr="ess-claims"
              class="ess-claims-menu"></li>
          <li gp-roles
              [userRoles]="['ESS_PAYSLIPS']"
              testId="ess-payslip-menu"
              gp-menu-item name="{{ 'MENU.ESS.payslips' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/ess/payslips']"
              data-attr="ess-payslips"
              class="ess-payslips-menu"></li>
        </ul>
      </li>
    </ng-container>

    <!-- My Team -->
    <ng-container *ngIf="essService.employee">
      <li gp-roles
          [userRoles]="['MSS_HIRE', 'MSS_MY_TEAM', 'MSS_PLANNING', 'MSS_REPORTS']"
          testId="mss-my-team-menu"
          gp-menu-dropdown
          [routerLinkActive]="['active']"
          name="{{ 'MENU.MSS.my_team' | translate }}"
          icon="fa-users-cog"
          class="mss-menu"
          data-attr="mss">
        <ul class="nav-sub">
          <li gp-roles
              [userRoles]="['MSS_HIRE']"
              testId="mss-hire-menu"
              class="mss-hire-menu"
              gp-menu-item name="{{ 'EMPLOYEE_HIRE.hire' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/mss/hire']"></li>
          <li gp-roles
              [userRoles]="['MSS_MY_TEAM']"
              testId="mss-employee-info-menu"
              class="mss-employee-info-menu"
              gp-menu-item name="{{ 'MENU.MSS.employee_info' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/mss/employee-info']"
              (click)="closeSideModal()"></li>
          <li gp-roles
              [userRoles]="['MSS_MY_TEAM']"
              testId="mss-backups-menu"
              gp-menu-item name="{{ 'MENU.ESS.backups' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/mss/backups']"
              [isNew]="true"
              data-attr="ess-backups"
              class="mss-backups-menu"></li>
          <li gp-roles
              [userRoles]="['MSS_PLANNING']"
              testId="mss-team-planning-menu"
              gp-menu-item name="{{ 'MENU.MSS.team_planning' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/mss/team-planning']"></li>
          <li gp-roles
              [userRoles]="['MSS_REPORTS']"
              testId="mss-reports-menu"
              gp-menu-item name="{{ 'MENU.MSS.reports' | translate }}"
              [routerLinkActive]="['active']"
              [routerLink]="['/mss/reports']"></li>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>
